import { Base, withBreakpointObserver } from '@studiometa/js-toolkit';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);

/**
 * @typedef {{}} HeroProps
 */

/**
 * Hero Hero.
 * @augments {Base<HeroProps>}
 */
export default class Hero extends withBreakpointObserver(Base) {
  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'Hero',
    refs: ['image'],
    options: {
      activeBreakpoints: {
        type: String,
        default: 'm l xl xxl',
      },
    },
  };

  /**
   *
   */
  mounted() {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: this.$el,
        start: 'top top',
        end: 'bottom top',
        scrub: true,
      },
    });
    tl.to(this.$refs.image, { y: -window.innerHeight / 4, ease: 'none' }, 0);
  }
}
